import { StyledProps } from '@front10';
import { Context } from '@front10/helpers/dist/Context';
import React, { useContext } from 'react';
import Box from '../../../elements/Box';
import Icon from '../../../elements/Icon';
import { IconProps } from '../../../elements/Icon/Icon';
import Text from '../../../elements/Text';

interface Props {
  showLeftIcon?: boolean;
  showLabel?: boolean;
  showRightIcon?: boolean;
  leftIcon?: string;
  labelKey?: string;
  rightIcon?: string;
  leftIconStyles?: IconProps;
  labelStyles?: StyledProps;
  rightIconStyles?: IconProps;
}

function Title({
  showLeftIcon = true,
  showLabel = true,
  showRightIcon = false,
  leftIcon = 'marker',
  labelKey = 'cmp-bus-directory-map-address',
  rightIcon = 'keyboard_arrow_down',
  leftIconStyles,
  labelStyles,
  rightIconStyles,
  ...props
}: StyledProps<Props>) {
  const { translate } = useContext(Context);
  return (
    <Box display="flex" alignItems="center" className="station-item-title" {...props}>
      {showLeftIcon && <Icon paddingRight="2" icon={leftIcon} size={25} {...leftIconStyles} />}
      {showLabel && <Text {...labelStyles}>{translate(labelKey, 'Address')}</Text>}
      {showRightIcon && <Icon icon={rightIcon} marginLeft="auto" {...rightIconStyles} />}
    </Box>
  );
}

Title.componentName = 'BusStation';

export default Title;
